module.exports = __webpack_public_path__ + "01f3f72feccc6684d2137302984c4bca.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-3.png
// module id = 3138
// module chunks = 0